export default __webpack_public_path__ + "static/media/DSC_7885.53bf9910.jpg";